import React, { CSSProperties, useState } from 'react';
import { Col, Row, truncateString } from '../../../../lib/utils';
import { colors } from '../../../../lib/colors';
import { Body3Bold, Body3Light, Body3Regular, CaptionBold, CaptionLight } from '../../../../lib/font';
import dayjs from 'dayjs';
import { I_GOING_ETC_SCHEDULE } from '../../../../types/images';
import styled, { keyframes } from 'styled-components';
import { LEGACY_WEEKLY_BLOCK_HEIGHT } from '../layout';

// 애니메이션 정의
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

interface StyledColProps {
    backgroundColor: string;
    isVisible: boolean;
}

// 스타일드 컴포넌트 정의
const HoverItem = styled.div<StyledColProps>`
    width: 300px;
    height: 192px;
    background-color: ${(props) => props.backgroundColor};
    display: flex;
    flex-direction: column;
    position: absolute;
    border-radius: 16px;
    box-shadow: 4px 4px 8px 0px #73737375;
    padding-left: 16px;
    padding-right: 24px;
    padding-top: 14px;
    z-index: 99;
    transition: all 1s ease;
    animation: ${(props) => (props.isVisible ? fadeIn : 'none')} 1s ease forwards;
`;

const EtcScheduleBlock = ({ onClickEtcOffSchedule, childItem, cellIndex }: any) => {
    const [showModal, setShowModal] = useState(false);
    const isGoingSchedule = dayjs().isAfter(childItem.startTime) && dayjs().isBefore(childItem.endTime);

    const hoverStyle: CSSProperties =
        cellIndex > 5
            ? {
                  right: '110%',
              }
            : {
                  left: '110%',
              };
    return (
        <Col
            onClick={() => {
                onClickEtcOffSchedule(childItem);
            }}
            style={{
                width: '95%',
                height: LEGACY_WEEKLY_BLOCK_HEIGHT,
                borderRadius: 4,
                border: '1.5px solid #6E6E6E',
                alignItems: 'flex-end',
                marginBottom: 4,
                backgroundColor: '#FAFAFA',
                cursor: 'pointer',
                boxShadow: showModal ? '0px 0px 12px 0px #73737382' : '',
                position: 'relative',
            }}
            onMouseEnter={() => setShowModal(true)}
            onMouseLeave={() => setShowModal(false)}
        >
            {isGoingSchedule && (
                <img
                    style={{
                        width: 24,
                        height: 18,
                        position: 'absolute',
                    }}
                    src={I_GOING_ETC_SCHEDULE}
                    alt=""
                />
            )}
            <Col
                style={{
                    width: '100%',
                    height: '100%',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <Col
                    style={{
                        width: '92%',
                        height: 34,
                        justifyContent: 'space-between',
                        overflow: 'hidden',
                    }}
                >
                    <Row style={{ alignItems: 'center', minWidth: 0, height: 16, gap: 6 }}>
                        <Body3Bold
                            style={{
                                color: colors.LAVEL_3,
                                fontSize: 13,
                                lineHeight: '16px',
                                whiteSpace: 'nowrap',
                                flexShrink: 0,
                            }}
                        >
                            {childItem?.coachName} 강사
                        </Body3Bold>
                        <CaptionBold style={{ color: colors.LAVEL_2, lineHeight: '16px', flexShrink: 0 }}>
                            일반
                        </CaptionBold>
                    </Row>
                    <Row style={{ alignItems: 'center', minWidth: 0, height: 15, gap: 8 }}>
                        <Body3Bold
                            style={{
                                color: colors.LAVEL_3,
                                fontSize: 13,
                                lineHeight: '15px',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                minWidth: 0,
                                flex: 1,
                            }}
                        >
                            {childItem?.name}
                        </Body3Bold>
                        <CaptionLight
                            style={{
                                color: colors.LAVEL_2,
                                lineHeight: '15px',
                                flexShrink: 0,
                            }}
                        >
                            {dayjs(childItem?.startTime).format('Ahh:mm').replace('오전', 'AM').replace('오후', 'PM')}
                            {' · '}
                            {childItem?.duration}분
                        </CaptionLight>
                    </Row>
                </Col>
            </Col>

            {showModal && (
                <HoverItem style={hoverStyle} backgroundColor={colors.WHITE_50} isVisible={showModal}>
                    <Row
                        style={{
                            alignItems: 'center',
                            justifyContent: 'space-between',
                        }}
                    >
                        <Row style={{ width: 200 }}>
                            <Col
                                style={{
                                    width: 8,
                                    height: 22,
                                    borderRadius: 8,
                                    backgroundColor: colors.GREY_400,
                                    marginRight: 11,
                                }}
                            />
                            <Body3Bold style={{ color: colors.LAVEL_3 }}>{`${childItem?.coachName} 강사`}</Body3Bold>
                        </Row>
                        <Row
                            style={{
                                width: 64,
                                height: 23,
                                borderRadius: 34,
                                border: '1px solid #737373',
                                color: colors.GREY_400,
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <CaptionBold>{'일반일정'}</CaptionBold>
                        </Row>
                    </Row>

                    <Body3Light style={{ color: colors.LAVEL_3, marginTop: 16 }}>
                        {dayjs(childItem?.startTime).format('M월 D일(ddd)')}
                    </Body3Light>
                    <Body3Bold style={{ color: colors.LAVEL_3, marginTop: 8 }}>
                        {dayjs(childItem?.startTime).format('A hh:mm ~ ')}
                        {dayjs(childItem?.endTime).format('A hh:mm ')}
                        {`(${childItem?.duration}분)`}
                    </Body3Bold>

                    <Body3Regular style={{ width: 252, color: colors.LAVEL_3, marginTop: 8 }}>
                        {truncateString(childItem?.name, 30)}
                    </Body3Regular>
                </HoverItem>
            )}
        </Col>
    );
};

export default EtcScheduleBlock;
